import { z } from 'zod';

/////////////////////////////////////////
// PAYOUTS SCHEMA
/////////////////////////////////////////

export const PayoutsSchema = z.object({
  id: z.bigint(),
  stripe_id: z.string().nullable(),
  status: z.string().nullable(),
  amount: z.string().nullable(),
  city_id: z.number().int().nullable(),
  stripe_event_type: z.string().nullable(),
  data: z.string().nullable(),
  account_id: z.bigint().nullable(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
  rowTimestamp: z.coerce.date(),
})

export type Payouts = z.infer<typeof PayoutsSchema>

export default PayoutsSchema;
